import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Mail, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("form"); // form | sending | sent
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setState("sending");
    try {
      await api.post("/auth/forgot-password", { email });
      setState("sent");
    } catch (err) {
      setError(apiError(err?.response?.data?.detail));
      setState("form");
    }
  };

  return (
    <div className="mx-auto max-w-xl px-4 py-16 sm:px-6">
      <Seo title="Forgot password" noindex />
      <div className="rounded-2xl border border-[#C89B3C]/30 bg-[#161118]/80 p-8">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-[#C89B3C]/15 text-[#C89B3C]">
          <Mail className="h-6 w-6" />
        </div>

        {state !== "sent" ? (
          <>
            <h1 className="mt-4 text-center font-serif text-2xl font-semibold text-amber-50">Forgot your password?</h1>
            <p className="mt-3 text-center text-amber-50/80">
              Enter the email address you signed up with and we will send you a link to choose a new one.
            </p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="mb-1.5 block text-sm font-medium text-foreground">Email</label>
                <input
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full rounded-xl border border-input bg-card px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-ring"
                />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <button
                type="submit"
                disabled={state === "sending"}
                className="flex w-full items-center justify-center gap-2 rounded-full bg-[#C89B3C] px-6 py-3 font-semibold text-black transition-transform hover:scale-[1.02] disabled:opacity-60"
              >
                {state === "sending" && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
              </button>
            </form>
          </>
        ) : (
          <>
            <h1 className="mt-4 text-center font-serif text-2xl font-semibold text-amber-50">Check your email</h1>
            <p className="mt-3 text-center text-amber-50/80">
              If an account exists for {email}, we have sent a link to choose a new password. It works for 60 minutes.
              If you cannot see it, check your junk folder.
            </p>
          </>
        )}

        <p className="mt-6 text-center text-sm">
          <Link to="/login" className="text-[#C89B3C] hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}